import {FileResponse} from "@/models/api/old/responses";
import {useGlobalStore} from "@/stores/GlobalStore";
import DateToStringHelper from "@/utilities/helpers/DateToStringHelper";

export default class ProjectFile {
    id:number|null;
    creatorId:number|null;
    creatorName:string|null;
    name:string;
    desc:string;
    type:string;
    size:number|null = null;
    urlGuid:string;
    deleteToDate:any; //DateTime?
    remindAboutDeleteDate:any; //DateTime?
    reminderSend:boolean;
    created:any; //DateTime?
    changed:any; //DateTime?
    deleted:any; //DateTime?
    deletedToken:string;
    content:any; //FormFile?
    isCompleted:boolean;
    uploadTicketGuid: string|null = null;
    messageToCreator: string|null = null;

    // only for webClient workflows
    file:File|null = null;
    callback:Function|null = null;
    // only for webClient search
    createdDateString:string|null;
    changedDateString:string|null;
    deletedDateString:string|null;
    deleteToDateString:string|null;

    constructor(respObj:FileResponse|null = null) {
        this.id = respObj?.fileID ?? null;
        this.creatorId = respObj?.fK_UserID ?? (useGlobalStore()).user?.id ?? -1;
        this.creatorName = respObj?.creatorName ?? null;
        this.name = respObj?.fileName ?? "";
        this.desc = respObj?.fileDesc ?? "";
        this.type = respObj?.fileType ?? "";
        this.size = respObj?.fileSize ?? null;
        this.urlGuid = respObj?.downloadURLGuid ?? "";
        this.deleteToDate = respObj?.deleteToDate ?? null;
        this.remindAboutDeleteDate = respObj?.remindAboutDeleteDate ?? null;
        this.reminderSend = respObj?.reminderSend ?? false;
        this.created = respObj?.created ?? null;
        this.changed = respObj?.changed ?? null;
        this.deleted = respObj?.deleted ?? null;
        this.deletedToken = respObj?.deletedToken ?? "";
        this.content = respObj?.content ?? null;
        this.isCompleted = respObj?.isCompleted ?? false;

        this.createdDateString = this.created ? DateToStringHelper(new Date(this.created)) : null;
        this.changedDateString = this.changed ? DateToStringHelper(new Date(this.changed)) : null;
        this.deletedDateString = this.deleted ? DateToStringHelper(new Date(this.deleted)) : null;
        this.deleteToDateString = this.deleteToDate ? DateToStringHelper(new Date(this.deleteToDate)) : null;
    }
}